import AccordionPanel from './AccordionPanel';
export default AccordionPanel;